// extracted by mini-css-extract-plugin
export default {"actions":"users-management_actions__Ie1i5","ColumnHead":"users-management_ColumnHead__ggWRA"};